import { z } from 'zod';

export const PaymentInitSchema = z.object({
  paymentURL: z.string().nonempty()
});

export type PaymentInitData = z.infer<typeof PaymentInitSchema>;

export interface PaymentInitRequestData {
  planId: string;
  subscriptionId: string;
}
